import React, { useEffect, useState } from 'react'
import { styled } from 'styled-components';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { Typography } from '@mui/material';
import axios from 'axios';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT

const Card = styled("div")({
    backgroundColor: `rgba(255, 255, 255, 1)`,
    boxShadow: `0px 0px 15px 1px rgba(0, 0, 0, 0.05)`,
    borderRadius: `40px`,
    width: '100%', 
    height: '100%', 
    margin: '0 auto',
    padding: '16px',
    
  });

  const Eclipse = styled("div")({
   // backgroundColor: `#ef5454`,
  border: '6px solid',
  borderColor: '#ffffff',
  borderRadius: `28px`,
  height: '56px',
  width: '56px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
    
  });

  const Icon = styled("div")({
    height: '32px',
    width: '32px',
    color: '#ffffff', // Icon color
    position: 'absolute', 
    
  });

  const steps = [
    'Created Account',
    'Expert Call',
    'Book Demo Class',
    'Enrolled in a Class',
    'Test assigned'
  ];

  const stepIcons = {
    'Created Account': '/studentdashboard_icons/created acc.svg',
    'Expert Call': '/studentdashboard_icons/created acc.svg',
    'Demo': '/studentdashboard_icons/Demo class.svg',
    'Enrolled in a Class': '/studentdashboard_icons/Enrolled-Class.svg',
    'Test assigned': '/studentdashboard_icons/Test assigned.svg',
  };

  const stepColors = [
    '#EF5454', 
    '#547bef',
    '#ffaf00', 
    '#00b046', 
    '#0086c0', 
  ];

function StudentTimeline() {
  const studentId = localStorage.getItem('studentId');
  const [timelineData, setTimelineData] = useState([]);

  useEffect(() => {
    // Make an API request to fetch timeline data
    axios.get(`${API_ENDPOINT}studentdashboard/timeline/${studentId}`)
      .then(response => {
        // Assuming your API response is an array of timeline objects
        if(response.status === 200){
        setTimelineData(response.data)
        } else if(response.status === 403){
          setTimelineData([])
        } else {
          console.log('Error fetching timeline data:', response);
        }
      })
      .catch(error => {
        console.error('Error fetching timeline data:', error);
      });
  }, []);

  const steps = timelineData.map(item => item.title);
  /*const stepColors = timelineData.map(item => {
    // Define colors based on the 'status' property or any other criteria
    return item.status === 0 ? 'green' : 'blue';
  });*/
  const dates = timelineData.map(item => new Date(item.createdAt).toLocaleDateString());

  return (
    <Card>
       <Typography variant='h4' sx={{color: '#000000', fontSize: '40px', fontWeight: '500', lineHeight: '28.8px'}}>Your Timeline</Typography>
       <Box sx={{ width: '100%', mt: '5px', justifyContent: 'center', }}>
      <Stepper activeStep={1} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel
                StepIconComponent={() => <CustomStepIcon label={label}  color={stepColors[index]}/>}
                sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
              >
                <Typography variant="caption" sx={{ color: '#000000', fontSize: '14px' }}>
                  {label}
                </Typography>
                <Typography variant="body2" sx={{ color: '#999999' }}>
                {dates[index]}
                </Typography>
              </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
    </Card>
  )
}

function CustomStepIcon({label, color}) {
  return (
    <Eclipse style={{ backgroundColor: color }}>
      <Icon>
        <img src={stepIcons[label]} /> {/* Display the icon based on the step label */}
      </Icon>
    </Eclipse>
  );
}

export default StudentTimeline